import { RSAA } from 'redux-api-middleware';
import { getGeolocation } from '../../utils/helper/page-behavior-helper';
import { getCoordinateAxleFromStorage, getRequestAdditionalHeader } from './util-actions';

export const FIND_CURRENT_LOAN_REPAYMENTS = '/customer/loan/current/re-payments';
export const FIND_CURRENT_LOAN_REPAYMENTS_SUCCESS = '/customer/loan/current/re-payments/success';
export const FIND_CURRENT_LOAN_REPAYMENTS_FAILURE = '/customer/loan/current/re-payments/failure';

export const PAYMENT_CARD = '/customer/loan/current/payment/card';
export const PAYMENT_CARD_SUCCESS = '/customer/loan/current/payment/card/success';
export const PAYMENT_CARD_FAILURE = '/customer/loan/current/payment/card/failure';

export const REFRESH_BILL = '/customer/loan/current/payment/card/refresh';
export const REFRESH_BILL_SUCCESS = '/customer/loan/current/payment/card/refresh/success';
export const REFRESH_BILL_FAILURE = '/customer/loan/current/payment/card/refresh/failure';

export const GET_BILL_BAR_CODE = '/customer/loan/current/payment/bill-bar-code';
export const GET_BILL_BAR_CODE_SUCCESS = '/customer/loan/current/payment/bill-bar-code/success';
export const GET_BILL_BAR_CODE_FAILURE = '/customer/loan/current/payment/bill-bar-code/failure';

export const GET_OR_CREATE_BILL = '/customer/loan/current/installment/bill';
export const GET_OR_CREATE_BILL_SUCCESS = '/customer/loan/current/installment/bill/success';
export const GET_OR_CREATE_BILL_FAILURE = '/customer/loan/current/installment/bill/failure';

export const GET_IS_DECLINED_BY_BANK = '/customer/loan/current/is-declined-by-bank';
export const GET_IS_DECLINED_BY_BANK_SUCCESS = '/customer/loan/current/is-declined-by-bank/success';
export const GET_IS_DECLINED_BY_BANK_FAILURE = '/customer/loan/current/is-declined-by-bank/failure';

export const CORRECT_BANK_ACCOUNT = '/customer/loan/current/correct-bank-account';
export const CORRECT_BANK_ACCOUNT_SUCCESS = '/customer/loan/current/correct-bank-account/success';
export const CORRECT_BANK_ACCOUNT_FAILURE = '/customer/loan/current/correct-bank-account/failure';

export const LOAN_IS_CP_APPROVED = '/customer/cp-approved';
export const LOAN_IS_CP_APPROVED_SUCCESS = '/customer/cp-approved/success';
export const LOAN_IS_CP_APPROVED_FAILURE = '/customer/cp-approved/failure';

export const SIMULATE_PAY_DAY_ = '/customer/loan/current/simulate-pay-day';
export const SIMULATE_PAY_DAY_SUCCESS = '/customer/loan/current/simulate-pay-day/success';
export const SIMULATE_PAY_DAY_FAILURE = '/customer/loan/current/simulate-pay-day/failure';

export const UNDERWRITE_PARTIAL = '/customer/loan/current/underwrite-partial';
export const UNDERWRITE_PARTIAL_SUCCESS = '/customer/loan/current/underwrite-partial/success';
export const UNDERWRITE_PARTIAL_FAILURE = '/customer/loan/current/underwrite-partial/failure';

/**
 * Finds the current re-payments.
 */
export function findCurrentLoanRePayments(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/current/re-payments`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [FIND_CURRENT_LOAN_REPAYMENTS, FIND_CURRENT_LOAN_REPAYMENTS_SUCCESS, FIND_CURRENT_LOAN_REPAYMENTS_FAILURE],
    },
  };
}

/**
 * Submit Card payment
 */
export function submitCardPayment(creditCard, amount, installmentsCard, device, paymentType, loanId) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/current/payment/card?amount=${amount}&installmentsCard=${installmentsCard}&billingMethod=${paymentType}&loanId=${loanId}`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify(creditCard).replace(/"\s+|\s+"/g, '"'),
      types: [PAYMENT_CARD, PAYMENT_CARD_SUCCESS, PAYMENT_CARD_FAILURE],
    },
  };
}

export function getRefreshBill(billId, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/current/payment/card/refresh?billId=${billId}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [REFRESH_BILL, REFRESH_BILL_SUCCESS, REFRESH_BILL_FAILURE],
    },
  };
}

export function requestBillBarCode(installmentNumber, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/current/re-payments/bill?installmentNumber=${installmentNumber}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [GET_BILL_BAR_CODE, GET_BILL_BAR_CODE_SUCCESS, GET_BILL_BAR_CODE_FAILURE],
    },
  };
}

/**
 * Get or create a new bill (returns a bill dto).
 */
export function getOrCreateBill(billingMethod, device, billId = null, installmentsNumbers = null) {
  getGeolocation();
  const params = [];
  if (billId) {
    params.push(`billId=${billId}`);
  }

  if (installmentsNumbers && installmentsNumbers.length > 0) {
    const numbers = installmentsNumbers.map((number) => `installmentsNumbers=${number}`);
    params.push(numbers.join('&'));
  }

  params.push(`billingMethod=${billingMethod}`);

  return {
    [RSAA]: {
      endpoint: `/api/loan/current/installment/bill?${params.join('&')}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      types: [GET_OR_CREATE_BILL, GET_OR_CREATE_BILL_SUCCESS, GET_OR_CREATE_BILL_FAILURE],
    },
  };
}

/**
 * Get boolean value if the loan is declined by bank.
 */
export function getIsDeclinedByBank() {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/underwriting/is-declined-by-bank`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [GET_IS_DECLINED_BY_BANK, GET_IS_DECLINED_BY_BANK_SUCCESS, GET_IS_DECLINED_BY_BANK_FAILURE],
    },
  };
}

/**
 * Correct bank account in underwriting phase.
 */
export function correctBankAccount(bankCode, branchNumber, accountNumber, checkDigit) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/underwriting/correct-bank-account`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify({
        bankCode,
        branchNumber,
        accountNumber,
        checkDigit,
      }).replace(/"\s+|\s+"/g, '"'),
      types: [CORRECT_BANK_ACCOUNT, CORRECT_BANK_ACCOUNT_SUCCESS, CORRECT_BANK_ACCOUNT_FAILURE],
    },
  };
}

export function loanApprovedInCreditPolicy() {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/cp-approved`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [LOAN_IS_CP_APPROVED, LOAN_IS_CP_APPROVED_SUCCESS, LOAN_IS_CP_APPROVED_FAILURE],
    },
  };
}

export function simulatePayDayChange(loanId, payDay) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/${loanId}/simulate-pay-day?payDay=${payDay}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [SIMULATE_PAY_DAY_, SIMULATE_PAY_DAY_SUCCESS, SIMULATE_PAY_DAY_FAILURE],
    },
  };
}

export function underwritePartial(loanId, payDay, originalDueDate) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/${loanId}/underwrite-partial?payDay=${payDay}&originalDueDate=${originalDueDate}`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [UNDERWRITE_PARTIAL, UNDERWRITE_PARTIAL_SUCCESS, UNDERWRITE_PARTIAL_FAILURE],
    },
  };
}
